import { render, staticRenderFns } from "./parcela.vue?vue&type=template&id=4c3f3aad"
import script from "./parcela.ts?vue&type=script&lang=js&external"
export * from "./parcela.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3f3aad')) {
      api.createRecord('4c3f3aad', component.options)
    } else {
      api.reload('4c3f3aad', component.options)
    }
    module.hot.accept("./parcela.vue?vue&type=template&id=4c3f3aad", function () {
      api.rerender('4c3f3aad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/financeiro/parcela.vue"
export default component.exports